import { useState, useEffect, useRef } from 'react';
import { execSeatableSql } from './seatable.js';
import SectionHeader from './sectionheader.js';

function Quotes(props) {
    const scrollRef = useRef(null);
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM \`Capability Quotes\` WHERE \`Capability\` IN ('${props.capability}')`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          const rowData = rows && rows.results;
          setData([...rowData, ...rowData, ...rowData]);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]); 
    /*
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    useEffect(() => {
        const slider = scrollRef.current;
        if (!slider) return;

        const totalWidth = slider.scrollWidth / 3;
        slider.scrollLeft = totalWidth;

        const handleScroll = () => {
            const maxScroll = totalWidth * 2;
            const scroll = slider.scrollLeft;
            const viewWidth = slider.clientWidth;

            if (scroll < viewWidth ) {
                slider.scrollLeft = scroll + totalWidth;
            } else if (scroll > (maxScroll - viewWidth)) {
                slider.scrollLeft = scroll - totalWidth;
            }
        }

        slider.addEventListener("scroll", handleScroll);
        return () => slider.removeEventListener("scroll", handleScroll);

    }, [data])

    useEffect(() => {
        const slider = scrollRef.current;
        if (!slider) return;

        const handleMouseDown = (e) => {
            setIsDown(true);
            slider.classList.add("dragging");
            setStartX(e.pageX - slider.offsetLeft);
            setScrollLeft(slider.scrollLeft);
        };

        const handleMouseLeave = () => {
            setIsDown(false);
            slider.classList.remove("dragging");
        };

        const handleMouseUp = () => {
            setIsDown(false);
            slider.classList.remove("dragging");
        };

        const handleMouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX);
            slider.scrollLeft = scrollLeft - walk;
        };

        slider.addEventListener("mousedown", handleMouseDown);
        slider.addEventListener("mouseleave", handleMouseLeave);
        slider.addEventListener("mouseup", handleMouseUp);
        slider.addEventListener("mousemove", handleMouseMove);

        return () => {
            slider.removeEventListener("mousedown", handleMouseDown);
            slider.removeEventListener("mouseleave", handleMouseLeave);
            slider.removeEventListener("mouseup", handleMouseUp);
            slider.removeEventListener("mousemove", handleMouseMove);
        };
    }, [data, isDown, scrollLeft, startX]);    
    */
    return <>
        {(data && (data.length > 0)) ? 
        <>
            <div id="Quotes" className='nav-margin'>
                <SectionHeader capability={props.capability} section="Quotes"/>
            </div>
            <div ref={scrollRef} className="infinite-scroll-container pb-5 border-bottom border-secondary">
                <div className="infinite-scroll-track">
                    {data.map((row, index) => (
                        <div key={index} className="infinite-scroll-card">
                            <div className='display-1'><i className="bi bi-quote"></i></div>
                            <div className='mt-3 fs-3 fst-italic'>{row.Quote}</div>
                            <div className="my-3 fs-5 fw-bold text-accent">{row.QuoteBy}</div>
                        </div>
                    ))}
                </div>
            </div>
        </> : ''}
    </>
}

export default Quotes;